// extracted by mini-css-extract-plugin
export default {"main":"styles_main__mlnaJ","title":"styles_title__Z79dP","text":"styles_text__JkAej"};